export enum EVerifyStatus {
  draft = 'draft',
  rework = 'rework',
  submitted = 'submitted',
  approved = 'approved',
  rejected = 'rejected',
  locked = 'locked',
}
